import { render } from "./Select.vue?vue&type=template&id=4deed872"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=4deed872&lang=css"
script.render = render

export default script